import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Persistent login: on a 401, silently refresh the access token using the
// long-lived refresh cookie, then retry the original request once.
let refreshPromise = null;
const AUTH_SKIP = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"];
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    if (status === 401 && !original._retry && !AUTH_SKIP.some((p) => url.includes(p))) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        await refreshPromise;
        return api(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export { API };
export default api;
